import ApiRequest from '../request'

export default class Users {
  constructor() {
    this.apiRequest = new ApiRequest()
  }
  async getListUsers(params) {
    try {
      const res = await this.apiRequest.get(`users`, params)
      return res
    } catch (error) {
      return error.response
    }
  }
  async roleIntances(payload) {
    try {
      const res = await this.apiRequest.post(`role_instances`, { ...payload })
      return res
    } catch (error) {
      return error.response
    }
  }
}
